import { Component, Input, SimpleChanges } from '@angular/core';
import { FirestoreService } from 'src/app/shared/services/firestore.service';

@Component({
  selector: 'app-userphotocard',
  templateUrl: './userphotocard.component.html',
  styleUrls: ['./userphotocard.component.scss']
})
export class UserphotocardComponent {

  @Input() photoNameMode: string = 'both';
  @Input() fromwhere: string = ''
  @Input() userId: string = '';
  @Input() fakeDisplayName: string = '';
  @Input() isNameShow: boolean = true;
  @Input() photoViewMode:string= '';
  @Input() showtooltip:boolean=true
  userObj: any; 

  constructor(private firestoreService: FirestoreService) { }

  ngOnInit(): void {

  }
  ngOnChanges(changes: SimpleChanges): void {
    this.getAuthDetails();
  }
  getAuthDetails() {
    console.log(this.userId);
    
    if (!this.userId) return;
    this.firestoreService.getUserProfile(this.userId).then((res: any) => {
// console.log(res);

      if (!res || res=="No user Details") return;
      this.userObj = res;
      this.userObj.displayName = res?.displayName;
      this.userObj.role = res.role;
    })
  }

}